import { SankeyLink } from '../types/sankey';

export const RTC2: SankeyLink[] = [
    {
        source: 103,
        target: 9,
        value: 1,
        valueid: 'targetba',
        paperName: 'DMC09',
        process: 'DMC09_1',
        id: 'DMC09-0',
        cluster: 'rtc2',
        imgUrl: 'KTkfwLw.png',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    { source: 9, target: 36, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-2', cluster: 'rtc2', imgUrl: 'KTkfwLw.png', color: 'intOneLight3LinkColor' },
    { source: 36, target: 58, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-4', cluster: 'rtc2', imgUrl: 'KTkfwLw.png', color: 'intOneLight3LinkColor' },
    { source: 58, target: 84, value: 1, valueid: 'targetba', paperName: 'DMC09', process: 'DMC09_1', id: 'DMC09-10', cluster: 'rtc2', imgUrl: 'KTkfwLw.png', color: 'repVisTechColor' },
    {
        source: 105,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-2',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 105,
        target: 16,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-4',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-10',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-18',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 39,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-20',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intTwoLinkColor',
    },
    {
        source: 16,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-25',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intTwoLinkColor',
    },
    {
        source: 63,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-26',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 63,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_5',
        id: 'EYG15-27',
        cluster: 'rtc2',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 111,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-2',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 111,
        target: 17,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-3',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 111,
        target: 18,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-4',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 111,
        target: 19,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-5',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-10',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 17,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-11',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 18,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-12',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 19,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-13',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-17',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-18',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 54,
        target: 84,
        value: 1,
        valueid: ['targetbb', 'targetcb', 'repb'],
        paperName: 'JTM11',
        process: 'JTM11_3',
        id: 'index-23',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'repVisTechColor',
    },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetbb', 'repf'],
        paperName: 'JTM11',
        process: 'JTM11_4',
        id: 'index-24',
        cluster: 'rtc2',
        imgUrl: 'AqAwugG.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 84, value: 1, valueid: ['targetbb', 'repf'], paperName: 'JTM11', process: 'JTM11_4', id: 'index-26', cluster: 'rtc2', imgUrl: 'AqAwugG.png', color: 'repVisTechColor' },
    {
        source: 114,
        target: 0,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-1',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 2,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-4',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 3,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-7',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 4,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-10',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 5,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-13',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 6,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-16',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 7,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-19',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 11,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-21',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 13,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-22',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 15,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-23',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 0,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-45',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 2,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-46',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 3,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-47',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 4,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-48',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 5,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-49',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 6,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-50',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 7,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-51',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { source: 11, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-59', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 13, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-60', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-61', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 11, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-68', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { source: 13, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-69', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { source: 15, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-70', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    {
        source: 46,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-82',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { source: 41, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-85', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 49, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-87', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    {
        source: 55,
        target: 84,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-93',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisTechColor',
    },
    { source: 55, target: 84, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-94', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    {
        source: 122,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-0',
        cluster: 'rtc2',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 122,
        target: 12,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-1',
        cluster: 'rtc2',
        imgUrl: 'Ak8KSur.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-2', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-3', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-4', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { source: 12, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-5', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    { source: 11, target: 49, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-6', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intFiveLight2LinkColor' },
    { source: 12, target: 49, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-7', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intFiveLight2LinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-8', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-9', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'intFourLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'MHK16',
        process: 'MHK16_1',
        id: 'MHK16-10',
        cluster: 'rtc2',
        imgUrl: 'Ak8KSur.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'MHK16', process: 'MHK16_1', id: 'MHK16-15', cluster: 'rtc2', imgUrl: 'Ak8KSur.jpg', color: 'repVisTechColor' },
    {
        source: 127,
        target: 14,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-0',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 127,
        target: 16,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-1',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 127,
        target: 16,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-2',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 14,
        target: 44,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-6',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 14, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-7', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    { source: 14, target: 49, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-8', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLight2LinkColor' },
    {
        source: 44,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-9',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 48, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-10', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_1',
        id: 'SCS16-11',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_1', id: 'SCS16-13', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        source: 16,
        target: 44,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-14',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 16, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-15', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-16',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 44,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-17',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 48, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-18', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'SCS16',
        process: 'SCS16_2',
        id: 'SCS16-19',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'SCS16', process: 'SCS16_2', id: 'SCS16-22', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        source: 16,
        target: 44,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-23',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 16, target: 48, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-24', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-25',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-26',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 48, target: 63, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-27', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS16',
        process: 'SCS16_3',
        id: 'SCS16-28',
        cluster: 'rtc2',
        imgUrl: 'ELyzRJL.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 63, target: 84, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS16', process: 'SCS16_3', id: 'SCS16-31', cluster: 'rtc2', imgUrl: 'ELyzRJL.jpg', color: 'repVisTechColor' },
    {
        source: 128,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-2',
        cluster: 'rtc2',
        imgUrl: 'h29usSh.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-24',
        cluster: 'rtc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 41,
        target: 54,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-25',
        cluster: 'rtc2',
        imgUrl: 'h29usSh.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 54,
        target: 84,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repb'],
        paperName: 'SCS17',
        process: 'SCS17_3',
        id: 'SCS17-27',
        cluster: 'rtc2',
        imgUrl: 'h29usSh.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 131,
        target: 21,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-7',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    {
        source: 131,
        target: 23,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-8',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 21, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-36', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 23, target: 46, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-37', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 21, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-38', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    { source: 23, target: 48, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-39', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 21,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-40',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 23,
        target: 49,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-41',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 46, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-42', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLinkColor' },
    { source: 48, target: 60, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-43', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['targetcb', 'repf'],
        paperName: 'VWH13',
        process: 'VWH13_4',
        id: 'VWH13-44',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 60, target: 84, value: 1, valueid: ['targetcb', 'repf'], paperName: 'VWH13', process: 'VWH13_4', id: 'VWH13-46', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'repVisTechColor' },
    {
        source: 133,
        target: 6,
        value: 1,
        valueid: 'targetba',
        paperName: 'XWL17',
        process: 'XWL17_4',
        id: 'XWL17-1',
        cluster: 'rtc2',
        imgUrl: 'VqSzaXU.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 133,
        target: 15,
        value: 1,
        valueid: 'targetba',
        paperName: 'XWL17',
        process: 'XWL17_2',
        id: 'XWL17-2',
        cluster: 'rtc2',
        imgUrl: 'VqSzaXU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 133,
        target: 16,
        value: 1,
        valueid: 'targetba',
        paperName: 'XWL17',
        process: 'XWL17_4',
        id: 'XWL17-4',
        cluster: 'rtc2',
        imgUrl: 'VqSzaXU.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 6, target: 49, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-6', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { source: 16, target: 49, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-8', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { source: 15, target: 45, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-9', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-12', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'intFourLinkColor' },
    { source: 61, target: 84, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_2', id: 'XWL17-15', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'repVisTechColor' },
    { source: 49, target: 61, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-17', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'intFiveLight2LinkColor' },
    { source: 61, target: 84, value: 1, valueid: 'targetba', paperName: 'XWL17', process: 'XWL17_4', id: 'XWL17-18', cluster: 'rtc2', imgUrl: 'VqSzaXU.jpg', color: 'repVisTechColor' },
    {
        source: 141,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-1',
        cluster: 'rtc2',
        imgUrl: 'sBwMjs9.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-8',
        cluster: 'rtc2',
        imgUrl: 'sBwMjs9.png',
        color: 'intTwoLinkColor',
    },
    {
        source: 39,
        target: 54,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-14',
        cluster: 'rtc2',
        imgUrl: 'sBwMjs9.png',
        color: 'intTwoLinkColor',
    },
    {
        source: 54,
        target: 84,
        value: 1,
        valueid: ['targetba', 'targetbb', 'repb'],
        paperName: 'YSK14',
        process: 'YSK14_1',
        id: 'YSK14-27',
        cluster: 'rtc2',
        imgUrl: 'sBwMjs9.png',
        color: 'repVisTechColor',
    },
    {
        source: 142,
        target: 16,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_5',
        id: 'CSL16-6',
        cluster: 'rtc2',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 43, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-25', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'intThreeLight1LinkColor' },
    { source: 43, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-26', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'intThreeLight1LinkColor' },
    { source: 62, target: 84, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_5', id: 'CSL16-28', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'repVisTechColor' },
    {
        source: 143,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-0',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 14,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-1',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 15,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-2',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-11', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 14, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-12', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-13', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 41, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-14', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 61, target: 84, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-15', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    {
        source: 144,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_2',
        id: 'YCC20-1',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 144,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-3',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 48, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-6', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intFiveLightLinkColor' },
    { source: 7, target: 49, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-7', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intFiveLight2LinkColor' },
    { source: 11, target: 32, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-9', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intOneLinkColor' },
    {
        source: 11,
        target: 42,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-11',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-12', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-13',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 48, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-15', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_2',
        id: 'YCC20-16',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-17',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 32, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-19', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'repVisTechColor' },
    {
        source: 42,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-20',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intThreeLightLinkColor',
    },
    { source: 45, target: 53, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-21', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'intFourLinkColor' },
    {
        source: 49,
        target: 53,
        value: 1,
        valueid: ['targetca', 'repc'],
        paperName: 'YCC20',
        process: 'YCC20_4',
        id: 'YCC20-22',
        cluster: 'rtc2',
        imgUrl: 'RYq4EGR.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_2', id: 'YCC20-27', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'repVisTechColor' },
    { source: 53, target: 84, value: 1, valueid: ['targetca', 'repc'], paperName: 'YCC20', process: 'YCC20_4', id: 'YCC20-28', cluster: 'rtc2', imgUrl: 'RYq4EGR.jpg', color: 'repVisTechColor' },
    {
        source: 156,
        target: 11,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_1',
        id: 'MEA17-0',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 11,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_2',
        id: 'MEA17-1',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 13,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_2',
        id: 'MEA17-2',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 14,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_2',
        id: 'MEA17-3',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 11,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_4',
        id: 'MEA17-5',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 15,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_4',
        id: 'MEA17-6',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 18,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_4',
        id: 'MEA17-7',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 11,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_5',
        id: 'MEA17-8',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 15,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_5',
        id: 'MEA17-9',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 156,
        target: 18,
        value: 1,
        valueid: ['targetaa'],
        paperName: 'MEA17',
        process: 'MEA17_5',
        id: 'MEA17-10',
        cluster: 'rtc2',
        imgUrl: 'ce97Hw7.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 34, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_1', id: 'MEA17-11', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLightLinkColor' },
    { source: 34, target: 61, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_1', id: 'MEA17-12', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLightLinkColor' },
    { source: 61, target: 84, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_1', id: 'MEA17-13', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'repVisTechColor' },
    { source: 11, target: 35, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_2', id: 'MEA17-14', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLight2LinkColor' },
    { source: 13, target: 35, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_2', id: 'MEA17-15', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLight2LinkColor' },
    { source: 14, target: 35, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_2', id: 'MEA17-16', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLight2LinkColor' },
    { source: 35, target: 61, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_2', id: 'MEA17-17', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intOneLight2LinkColor' },
    { source: 61, target: 84, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_2', id: 'MEA17-19', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'repVisTechColor' },
    { source: 11, target: 47, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_4', id: 'MEA17-24', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 15, target: 47, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_4', id: 'MEA17-25', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 47, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_4', id: 'MEA17-26', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 47, target: 61, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_4', id: 'MEA17-27', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 61, target: 84, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_4', id: 'MEA17-29', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'repVisTechColor' },
    { source: 11, target: 48, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_5', id: 'MEA17-30', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 15, target: 48, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_5', id: 'MEA17-31', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 48, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_5', id: 'MEA17-32', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 48, target: 61, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_5', id: 'MEA17-33', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'intFiveLightLinkColor' },
    { source: 61, target: 84, value: 1, valueid: ['targetaa'], paperName: 'MEA17', process: 'MEA17_5', id: 'MEA17-36', cluster: 'rtc2', imgUrl: 'ce97Hw7.jpg', color: 'repVisTechColor' },
    {
        source: 157,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-6',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 12,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-7',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 16,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-8',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-23',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-24',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-25',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-26',
        cluster: 'rtc2',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 84, value: 1, valueid: ['targetaa', 'repd'], paperName: 'SFJ16', process: 'SFJ16_3', id: 'SFJ16-27', cluster: 'rtc2', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
    { source: 113, target: 9, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-1', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'targetLinkOneColor', status: 'selected' },
    { source: 113, target: 10, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-4', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'targetLinkOneColor', status: 'selected' },
    { source: 9, target: 36, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-11', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 10, target: 36, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-14', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 36, target: 55, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-22', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'intOneLight3LinkColor' },
    { source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'JX17', process: 'JX17_2', id: 'JX17-31', cluster: 'rtc2', imgUrl: 'dbYhmdg.jpg', color: 'repVisTechColor' },
    {
        source: 114,
        target: 0,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-1',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 2,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-4',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 3,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-7',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 4,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-10',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 5,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-13',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 6,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-16',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 7,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-19',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 11,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-21',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 13,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-22',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 114,
        target: 15,
        value: 1,
        valueid: 'repd',
        paperName: 'KSBK15',
        process: 'KSBK15_4',
        id: 'KSBK15-23',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 0,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-45',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 2,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-46',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 3,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-47',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 4,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-48',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 5,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-49',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 6,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-50',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    {
        source: 7,
        target: 46,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-51',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { source: 11, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-59', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 13, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-60', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-61', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 11, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-68', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { source: 13, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-69', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    { source: 15, target: 49, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-70', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    {
        source: 46,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-82',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'intFiveLinkColor',
    },
    { source: 41, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-85', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intThreeLinkColor' },
    { source: 49, target: 55, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-87', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'intFiveLight2LinkColor' },
    {
        source: 55,
        target: 85,
        value: 1,
        valueid: ['repd', 'targetba', 'targetbb'],
        paperName: 'KSBK15',
        process: 'KSBK15_2',
        id: 'KSBK15-95',
        cluster: 'rtc2',
        imgUrl: 'AY0EaHs.png',
        color: 'repVisTechColor',
    },
    { source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'KSBK15', process: 'KSBK15_4', id: 'KSBK15-96', cluster: 'rtc2', imgUrl: 'AY0EaHs.png', color: 'repVisTechColor' },
    {
        source: 115,
        target: 5,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'LGX16',
        process: 'LGX16_3',
        id: 'LGX16-2',
        cluster: 'rtc2',
        imgUrl: 'WcypLMa.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    { source: 5, target: 40, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'LGX16', process: 'LGX16_3', id: 'LGX16-9', cluster: 'rtc2', imgUrl: 'WcypLMa.png', color: 'intTwoLightLinkColor' },
    { source: 40, target: 55, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'LGX16', process: 'LGX16_3', id: 'LGX16-18', cluster: 'rtc2', imgUrl: 'WcypLMa.png', color: 'intTwoLightLinkColor' },
    { source: 55, target: 85, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'LGX16', process: 'LGX16_3', id: 'LGX16-27', cluster: 'rtc2', imgUrl: 'WcypLMa.png', color: 'repVisTechColor' },
    {
        source: 117,
        target: 18,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'LLN14',
        process: 'LLN14_3',
        id: 'LLN14-3',
        cluster: 'rtc2',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 18, target: 48, value: 1, valueid: ['targetab', 'repd'], paperName: 'LLN14', process: 'LLN14_3', id: 'LLN14-17', cluster: 'rtc2', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLightLinkColor' },
    { source: 48, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'LLN14', process: 'LLN14_3', id: 'LLN14-18', cluster: 'rtc2', imgUrl: 'xWQU5gc.jpg', color: 'intFiveLightLinkColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'LLN14', process: 'LLN14_3', id: 'LLN14-20', cluster: 'rtc2', imgUrl: 'xWQU5gc.jpg', color: 'repVisTechColor' },
    {
        source: 121,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_2',
        id: 'MEV16-1',
        cluster: 'rtc2',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 121,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'MEV16',
        process: 'MEV16_2',
        id: 'MEV16-2',
        cluster: 'rtc2',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 121,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_3',
        id: 'MEV16-3',
        cluster: 'rtc2',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 121,
        target: 13,
        value: 1,
        valueid: ['targetaa', 'repf'],
        paperName: 'MEV16',
        process: 'MEV16_3',
        id: 'MEV16-4',
        cluster: 'rtc2',
        imgUrl: 'FpTZ8Nt.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 35, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-13', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-14', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 13, target: 35, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-15', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 13, target: 45, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-16', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 35, target: 55, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-17', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-18', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetaa', 'repd'], paperName: 'MEV16', process: 'MEV16_2', id: 'MEV16-19', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisTechColor' },
    { source: 11, target: 35, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-20', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-21', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 13, target: 35, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-22', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 13, target: 45, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-23', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 35, target: 60, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-24', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intOneLight2LinkColor' },
    { source: 45, target: 60, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-25', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'intFourLinkColor' },
    { source: 60, target: 85, value: 1, valueid: ['targetaa', 'repf'], paperName: 'MEV16', process: 'MEV16_3', id: 'MEV16-26', cluster: 'rtc2', imgUrl: 'FpTZ8Nt.jpg', color: 'repVisTechColor' },
    {
        source: 123,
        target: 17,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-3',
        cluster: 'rtc2',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 123,
        target: 19,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-4',
        cluster: 'rtc2',
        imgUrl: 'U35x588.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 17, target: 48, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-14', cluster: 'rtc2', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 17,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-15',
        cluster: 'rtc2',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 19, target: 48, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-16', cluster: 'rtc2', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 19,
        target: 49,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-17',
        cluster: 'rtc2',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 48, target: 55, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-24', cluster: 'rtc2', imgUrl: 'U35x588.png', color: 'intFiveLightLinkColor' },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['repd', 'targetca'],
        paperName: 'MVM17',
        process: 'MVM17_2',
        id: 'MVM17-25',
        cluster: 'rtc2',
        imgUrl: 'U35x588.png',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 85, value: 1, valueid: ['repd', 'targetca'], paperName: 'MVM17', process: 'MVM17_2', id: 'MVM17-30', cluster: 'rtc2', imgUrl: 'U35x588.png', color: 'repVisTechColor' },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'PC15PV',
        process: 'PC15PV_3',
        id: 'PC15PV-15',
        cluster: 'rtc2',
        imgUrl: 'C2IpSkW.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'PC15PV', process: 'PC15PV_3', id: 'PC15PV-22', cluster: 'rtc2', imgUrl: 'C2IpSkW.jpg', color: 'repVisTechColor' },
    { source: 130, target: 1, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-0', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'targetLinkColor', status: 'selected' },
    { source: 130, target: 3, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-1', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'targetLinkColor', status: 'selected' },
    {
        source: 130,
        target: 11,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_1',
        id: 'SSK12-2',
        cluster: 'rtc2',
        imgUrl: 'chAdr4B.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 130,
        target: 13,
        value: 1,
        valueid: 'repf',
        paperName: 'SSK12',
        process: 'SSK12_1',
        id: 'SSK12-3',
        cluster: 'rtc2',
        imgUrl: 'chAdr4B.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 1, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-6', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'intTwoLinkColor' },
    { source: 3, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-7', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'intTwoLinkColor' },
    { source: 11, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-8', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'intTwoLinkColor' },
    { source: 13, target: 39, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-9', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'intTwoLinkColor' },
    { source: 39, target: 60, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-10', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'intTwoLinkColor' },
    { source: 60, target: 85, value: 1, valueid: 'repf', paperName: 'SSK12', process: 'SSK12_1', id: 'SSK12-12', cluster: 'rtc2', imgUrl: 'chAdr4B.png', color: 'repVisTechColor' },
    {
        source: 131,
        target: 16,
        value: 1,
        valueid: 'targetcb',
        paperName: 'VWH13',
        process: 'VWH13_2',
        id: 'VWH13-4',
        cluster: 'rtc2',
        imgUrl: 'TO07ZUT.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 48, value: 1, valueid: 'targetcb', paperName: 'VWH13', process: 'VWH13_2', id: 'VWH13-20', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    { source: 48, target: 66, value: 1, valueid: 'targetcb', paperName: 'VWH13', process: 'VWH13_2', id: 'VWH13-21', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'intFiveLightLinkColor' },
    { source: 66, target: 85, value: 1, valueid: 'targetcb', paperName: 'VWH13', process: 'VWH13_2', id: 'VWH13-24', cluster: 'rtc2', imgUrl: 'TO07ZUT.jpg', color: 'repVisTechColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_1',
        id: 'XWS16-2',
        cluster: 'rtc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_2',
        id: 'XWS16-3',
        cluster: 'rtc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 134,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_6',
        id: 'XWS16-5',
        cluster: 'rtc2',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-8', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-10', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 16, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-13', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 39, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-16', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-20', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-21', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-31', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-32', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { source: 55, target: 85, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-33', cluster: 'rtc2', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    {
        source: 139,
        target: 16,
        value: 1,
        valueid: 'repd',
        paperName: 'RSRY12',
        process: 'RSRY12_3',
        id: 'RSRY12-2',
        cluster: 'rtc2',
        imgUrl: 'ivVW2HN.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 45, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-6', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    { source: 45, target: 55, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-9', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    { source: 55, target: 85, value: 1, valueid: 'repd ', paperName: 'RSRY12', process: 'RSRY12_3', id: 'RSRY12-14', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'repVisTechColor' },
    {
        source: 142,
        target: 11,
        value: 1,
        valueid: 'repd',
        paperName: 'CSL16',
        process: 'CSL16_1',
        id: 'CSL16-0',
        cluster: 'rtc2',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-9', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 39, target: 55, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-10', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 55, target: 85, value: 1, valueid: 'repd', paperName: 'CSL16', process: 'CSL16_1', id: 'CSL16-12', cluster: 'rtc2', imgUrl: 'mt871Nx.png', color: 'repVisTechColor' },
    {
        source: 102,
        target: 17,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-7',
        cluster: 'rtc2',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 18,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-8',
        cluster: 'rtc2',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 102,
        target: 19,
        value: 1,
        valueid: ['targetab', 'reph'],
        paperName: 'CSL12',
        process: 'CSL12_4',
        id: 'CSL12-9',
        cluster: 'rtc2',
        imgUrl: 'a3kehFc.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 17, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-20', cluster: 'rtc2', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-21', cluster: 'rtc2', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 19, target: 48, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-22', cluster: 'rtc2', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 48, target: 62, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-29', cluster: 'rtc2', imgUrl: 'a3kehFc.jpg', color: 'intFiveLightLinkColor' },
    { source: 62, target: 99, value: 1, valueid: ['targetab', 'reph'], paperName: 'CSL12', process: 'CSL12_4', id: 'CSL12-42', cluster: 'rtc2', imgUrl: 'a3kehFc.jpg', color: 'repVisTechColor' },
    { source: 116, target: 3, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-0', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    { source: 116, target: 3, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-1', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    { source: 116, target: 3, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-3', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    {
        source: 116,
        target: 11,
        value: 1,
        valueid: 'repa',
        paperName: 'LJC18',
        process: 'LJC18_8',
        id: 'LJC18-6',
        cluster: 'rtc2',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 116,
        target: 11,
        value: 1,
        valueid: 'repf',
        paperName: 'LJC18',
        process: 'LJC18_7',
        id: 'LJC18-7',
        cluster: 'rtc2',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 116,
        target: 23,
        value: 1,
        valueid: 'repa',
        paperName: 'LJC18',
        process: 'LJC18_10',
        id: 'LJC18-9',
        cluster: 'rtc2',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 3, target: 49, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-13', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 3, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-14', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 3, target: 49, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-15', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 11, target: 49, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-16', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 11, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-17', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 23, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-18', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-23', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 60, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-24', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 62, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-25', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-26', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-27', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-28', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 60, target: 99, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_3', id: 'LJC18-40', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 60, target: 99, value: 1, valueid: 'repf', paperName: 'LJC18', process: 'LJC18_7', id: 'LJC18-41', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 62, target: 99, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-42', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-43', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_8', id: 'LJC18-44', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 63, target: 99, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-45', cluster: 'rtc2', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    {
        source: 120,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_1',
        id: 'MDD10-0',
        cluster: 'rtc2',
        imgUrl: 'AA3ZOvl.png',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 120,
        target: 11,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_2',
        id: 'MDD10-1',
        cluster: 'rtc2',
        imgUrl: 'AA3ZOvl.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 120,
        target: 15,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_4',
        id: 'MDD10-3',
        cluster: 'rtc2',
        imgUrl: 'AA3ZOvl.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 39, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-7', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLinkColor' },
    { source: 7, target: 49, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-9', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intFiveLight2LinkColor' },
    { source: 11, target: 39, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-10', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLinkColor' },
    { source: 11, target: 40, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-11', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLightLinkColor' },
    { source: 15, target: 40, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_4', id: 'MDD10-12', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLightLinkColor' },
    { source: 39, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-13', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLinkColor' },
    { source: 39, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-14', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLinkColor' },
    { source: 40, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-15', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLightLinkColor' },
    { source: 40, target: 54, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_4', id: 'MDD10-16', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'intTwoLightLinkColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_1', id: 'MDD10-22', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_2', id: 'MDD10-23', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetca', 'repb'], paperName: 'MDD10', process: 'MDD10_4', id: 'MDD10-24', cluster: 'rtc2', imgUrl: 'AA3ZOvl.png', color: 'repVisTechColor' },
    {
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetca', 'repb'],
        paperName: 'MDD10',
        process: 'MDD10_1',
        id: 'MDD10-33',
        cluster: 'rtc2',
        imgUrl: 'AA3ZOvl.png',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 135,
        target: 16,
        value: 1,
        valueid: ['repf', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_3',
        id: 'YFS10-16',
        cluster: 'rtc2',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 45, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-17', cluster: 'rtc2', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 45, target: 60, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-18', cluster: 'rtc2', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 60, target: 86, value: 1, valueid: ['repf', 'targetbb'], paperName: 'YFS10', process: 'YFS10_3', id: 'YFS10-20', cluster: 'rtc2', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        source: 139,
        target: 11,
        value: 1,
        valueid: ['repd ', 'targetbb'],
        paperName: 'RSRY12',
        process: 'RSRY12_1',
        id: 'RSRY12-0',
        cluster: 'rtc2',
        imgUrl: 'ivVW2HN.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'RSRY12', process: 'RSRY12_1', id: 'RSRY12-4', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'RSRY12', process: 'RSRY12_1', id: 'RSRY12-8', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'intFourLinkColor' },
    { source: 55, target: 86, value: 1, valueid: ['repd ', 'targetbb'], paperName: 'RSRY12', process: 'RSRY12_1', id: 'RSRY12-15', cluster: 'rtc2', imgUrl: 'ivVW2HN.png', color: 'repVisTechColor' },
    {
        source: 141,
        target: 16,
        value: 1,
        valueid: 'repb',
        paperName: 'YSK14',
        process: 'YSK14_3',
        id: 'YSK14-2',
        cluster: 'rtc2',
        imgUrl: 'sBwMjs9.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 16, target: 48, value: 1, valueid: 'repb', paperName: 'YSK14', process: 'YSK14_3', id: 'YSK14-9', cluster: 'rtc2', imgUrl: 'sBwMjs9.png', color: 'intFiveLightLinkColor' },
    { source: 48, target: 54, value: 1, valueid: 'repb', paperName: 'YSK14', process: 'YSK14_3', id: 'YSK14-19', cluster: 'rtc2', imgUrl: 'sBwMjs9.png', color: 'intFiveLightLinkColor' },
    { source: 54, target: 86, value: 1, valueid: 'repb', paperName: 'YSK14', process: 'YSK14_3', id: 'YSK14-28', cluster: 'rtc2', imgUrl: 'sBwMjs9.png', color: 'repVisTechColor' },
    {
        source: 143,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-0',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 14,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-1',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 15,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-2',
        cluster: 'rtc2',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-11', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 14, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-12', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-13', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 41, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-14', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 61, target: 86, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-16', cluster: 'rtc2', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    {
        source: 147,
        target: 5,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_1',
        id: 'MDJW07-0',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 147,
        target: 13,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-3',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 147,
        target: 14,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-7',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 5,
        target: 34,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_1',
        id: 'MDJW07-11',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 13,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-14',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 14,
        target: 49,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-18',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 34,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_1',
        id: 'MDJW07-22',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_4',
        id: 'MDJW07-25',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDJW07',
        process: 'MDJW07_7',
        id: 'MDJW07-26',
        cluster: 'rtc2',
        imgUrl: 'E21AFdm.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 54, target: 86, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_1', id: 'MDJW07-37', cluster: 'rtc2', imgUrl: 'E21AFdm.jpg', color: 'repVisTechColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_4', id: 'MDJW07-38', cluster: 'rtc2', imgUrl: 'E21AFdm.jpg', color: 'repVisTechColor' },
    { source: 54, target: 86, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDJW07', process: 'MDJW07_7', id: 'MDJW07-39', cluster: 'rtc2', imgUrl: 'E21AFdm.jpg', color: 'repVisTechColor' },
];
